<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import AButton from '../AButton/AButton.vue'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '../dropdown-menu'
import type { TableFilterOptions, TableFilterValueOptions } from '.'
import TableFilter from './TableFilter.vue'

const properties = defineProps<{
  filters: TableFilterOptions[]
}>()

const activeFilters = defineModel<Record<string, TableFilterValueOptions>>({ required: true })
const open = ref<boolean>(false)
const subOpen = ref<Record<string, boolean>>({})
function toggleOpen() {
  open.value = !open.value
}

function setSubOpen(id: string, open: boolean) {
  subOpen.value[`${id}`] = open
}

function onReset(filter: TableFilterOptions) {
  delete activeFilters.value[filter.id]
}

const { t } = useI18n({
  messages: {
    en: {
      addFilter: 'Add filter',
    },
    nl: {
      addFilter: 'Filter toevoegen',
    },
  },
})

const visibleFilters = computed(() => (properties.filters || []).filter((filter) => (filter.visible === undefined || filter.visible) && filter.label))
</script>

<template>
  <DropdownMenu v-model:open="open" align="start">
    <DropdownMenuTrigger as-child>
      <AButton variant="outline" @click="toggleOpen">{{ t('addFilter') }}</AButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" class="w-64">
      <DropdownMenuGroup v-for="filter in visibleFilters" :key="filter.id">
        <DropdownMenuSub :open="subOpen[filter.id]" @update:open="(open) => setSubOpen(filter.id, open)">
          <DropdownMenuSubTrigger>
            <span>{{ filter.label }}</span>
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent class="w-80 p-0">
              <TableFilter v-model:model-value="activeFilters[filter.id]" :filter="filter" @close="toggleOpen()" @reset="onReset(filter)" />
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
      </DropdownMenuGroup>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
